module.exports = __webpack_public_path__ + "img/redPackage.9ed53926.png";